import { useRecoilValue } from 'recoil';
import { selectedDeviceStateAtom } from '../models/atoms/device_atoms';

export const MIN_WARNING_PERCENTAGE = 5;
export const MAX_WARNING_PERCENTAGE = 95;

export function useWarningLevel() {
  const selectedDevice = useRecoilValue(selectedDeviceStateAtom);
  const minMM = selectedDevice
    ? Math.floor(
        (MIN_WARNING_PERCENTAGE / 100) * selectedDevice.backend_max_height_mm,
      )
    : 0;
  const maxMM = selectedDevice
    ? Math.ceil(
        (MAX_WARNING_PERCENTAGE / 100) * selectedDevice.backend_max_height_mm,
      )
    : 0;

  function toWarningDistance(percentage: number): number {
    const val =
      (percentage / 100) * (selectedDevice?.backend_max_height_mm ?? 0);
    return Math.round(val * 10) / 10;
  }

  function toWarningPercentage(distanceMM: number): number {
    return (distanceMM / (selectedDevice?.backend_max_height_mm ?? 0)) * 100;
  }

  return {
    minMM,
    maxMM,
    toWarningDistance,
    toWarningPercentage,
  };
}
